"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageViewEvent = exports.Instrument = void 0;
var _instrumentBase = require("../../utils/instrument-base");
var CONSTANTS = _interopRequireWildcard(require("../constants"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */

class Instrument extends _instrumentBase.InstrumentBase {
  static featureName = CONSTANTS.FEATURE_NAME;
  constructor(agentRef, auto = true) {
    super(agentRef, CONSTANTS.FEATURE_NAME, auto);
    this.importAggregator(agentRef);
  }
}
exports.Instrument = Instrument;
const PageViewEvent = exports.PageViewEvent = Instrument;